import { createSlice } from '@reduxjs/toolkit';
import api from '../../utils/api';
import { clearPersistedAuth } from '../../utils/auth';

const initialState = { user: null, token: null, isAuthenticated: false, loading: false, error: null };

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (s,a) => { s.loading = a.payload; },
    setError: (s,a) => { s.error = a.payload; s.loading = false; },
    loginSuccess: (s,a) => { s.user = a.payload.user; s.token = a.payload.token; s.isAuthenticated = true; s.loading = false; s.error = null; },
    registerSuccess: (s,a) => { s.user = a.payload.user; s.token = a.payload.token; s.isAuthenticated = true; s.loading = false; s.error = null; },
    logoutSuccess: (s) => { s.user = null; s.token = null; s.isAuthenticated = false; s.loading = false; s.error = null; },
  },
});

export const { setLoading, setError, loginSuccess, registerSuccess, logoutSuccess } = slice.actions;

export const logout = (sessionId) => async (dispatch) => {
  try { await api.post('/auth/logout', { sessionId }); } catch {}
  clearPersistedAuth();
  dispatch(logoutSuccess());
  window.location.href = '/login';
};

export default slice.reducer;
